import React, {useCallback, useEffect, useRef, useState} from 'react';
import {Box} from '@mui/material';
import {ContentWrapper, MainWrapper} from '../Components/StyledComponents';
import Header from './Header';
import LeftSideBar from './LeftSideBar';
import WebFont from 'webfontloader';
import {useDispatch, useSelector} from "react-redux";
import {
    TogglePageMenuClose,
    TogglePageMenuOpen
} from "../assets/icons";
import {getFabricCanvas} from "../utils/canvasInitializer";
import {setActiveObject, setActiveSetting, setFabricCanvasInstance} from "../store/reducers/canvasSlice";
import YourPage from "../Components/YourPage";
import {
    applyFeathering,
    createThumbnail, enlivenFabricObjectList, fitGroupInsideCanvas,
    getFabricInstances, getStoredSheets,
    initSheets, logIfStoredDataExists,
    modifiedImagesList, saveEditor, setCanvasBackground, URLMakerForThumbnails
} from "../utils/helpers";
import {initAligningGuidelines} from '../utils/guideLines'
import {setSheetList, updateSheetThumbnail} from "../store/reducers/availableSheets";
import {webFontList} from "../utils/fonts";
import '../utils/fabricOverrides'
import {setTextValue} from "../store/reducers/TextValue";
import Toolbar from "./Toolbar";
import {
    getAdminTemplateByIdForEdit, getGlobalAssetsData,
    getImagesData,
    getTemplateByIdForCopy, getTemplateByIdForEdit
} from "../utils/apiHelper";
import {setAssetList, setUserImagesList} from "../store/reducers/userImagesListSlice";
import {setPanelKey} from "../store/reducers/panleKey";
import {setObjectsState} from "../store/reducers/objectState";
import Loader from "../Components/Loader";
import {handleKeyboardShortcuts} from "../utils/KeyboardShortcuts";
import {updateUndoRedoState} from "../utils/undo-redo";
import {setIsEditing, setIsLoggedIn, setSharedId, setShareImages} from "../store/reducers/loginSlice";
import { useParams} from 'react-router-dom';
import {setActiveSheet} from "../store/reducers/activeSheet";
import {fabric} from "fabric";
import {setLoading} from "../store/reducers/modalToggler";
import Sheet from "../utils/sheet";
import History from "../utils/history";
import {showToast} from "../store/reducers/notificationSlice";
import {ToastContainer} from "react-toastify";
import {useTour} from "@reactour/tour";

let canvas;
const AfterLifeEditor = ({ action }) => {
    const dispatch = useDispatch();
    const canvasWrapperRef = useRef()
    const { setIsOpen } = useTour()
    const { id } = useParams();
    const activeSheet = useSelector((state) => state.activeSheet).sheet;
    const availableSheets = useSelector((state) => state.availableSheets).sheets;
    const {isLoading} = useSelector((state) => state.modalToggle);
    const { isLoggedIn } = useSelector((state) => state.loginSlice);

    const [activeSheetIndex, setActiveSheetIndex] = useState(0);
    const [togglePage, setTogglePage] = useState(true)
    const [toggleSubMenu, setToggleSubMenu] = useState(true);

    useEffect(() => {
        setIsOpen(true)
        if (id) {
            dispatch(setLoading(true));
        }
        switch (action) {
            case 'createCopy':
                handleTemplateLoading(action, id, getTemplateByIdForCopy);
                break;
            case 'editProject':
                handleTemplateLoading(action, id, getTemplateByIdForEdit);
                break;
            case 'editTemplate':
                handleTemplateLoading(action, id, getAdminTemplateByIdForEdit);
                break;
            default:
                // const isStoredEditor = localStorage.getItem('afterlife_editor_storage');
                // if (isStoredEditor && isStoredEditor !== '') {
                //     loadStoredEditor().then();
                // } else {
                //     initCanvas(activeSheet);
                // }
                initCanvas(activeSheet);
                break;
        }
    }, [id]);

    useEffect(() => {
        if (isLoggedIn) {
            getImagesData('', 1).then(async (res) => {
                const data = await modifiedImagesList(res, activeSheet);
                dispatch(setUserImagesList(data));
            }).catch((err) => {
                if (err.response && err.response.status === 403) {
                    dispatch(showToast({ message: "Session expired. Login Again", type: "error" }));
                    sessionStorage.setItem('auth_token', '')
                    dispatch(setIsLoggedIn(false));
                } else {
                    console.error(err);
                }
            });
            getGlobalAssetsData('general', 1).then(async (res) => {
                const data = await modifiedImagesList(res, activeSheet);
                dispatch(setAssetList({type: 'image_graphic', data}));
            })
            getGlobalAssetsData('shape', 1).then(async (res) => {
                const data = await modifiedImagesList(res, activeSheet);
                dispatch(setAssetList({type: 'shape', data}));
            })
            getGlobalAssetsData('text_graphic', 1).then(async (res) => {
                const data = await modifiedImagesList(res, activeSheet);
                dispatch(setAssetList({type: 'text_graphic', data}));
            })
        }
    }, [isLoggedIn]);

    useEffect(() => {
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(()=>{
        const canvasWrapper = canvasWrapperRef.current;
           resizeCanvas(canvasWrapper, canvas).then();
           if(window.isResized) fitGroupInsideCanvas(canvas);
    },[window.activeSheet])

    window.onbeforeunload = async (event) => {
        const e = event || window.event;
        const route = window.location.pathname.split('/').pop();

        if (e && !isLoggedIn && route === '') {
            e.returnValue = ''; // Legacy method for cross browser support to show an alert for reload site.
        }
        if (isLoggedIn && route === '') {
            // await saveEditor('auto-save', availableSheets, activeSheet, canvas);
            e.returnValue = undefined;
        }
    };

    const autoSaveHandler = useCallback(() => {
        console.log(`%c[AutoSave] Progress saved at ${new Date().toLocaleTimeString()}`, 'color:yellow');
        console.log('[AutoSave] Data saved: ', { availableSheets, activeSheet, canvas });
        saveEditor('auto-save', availableSheets, activeSheet, canvas);
    }, [availableSheets, activeSheet, canvas]);

    // useEffect(() => {
    //     const intervalId = setInterval(() => {
    //         autoSaveHandler();
    //     }, 1000 * 30);
    //     return () => clearInterval(intervalId);
    // }, [autoSaveHandler]);

    const loadStoredEditor = async () => {
        logIfStoredDataExists();
        loadWebFonts(undefined).then(async () => {
            const { storedAvailableSheets, storedActiveSheet, thumbnails} = await getStoredSheets();
            await loadTemplate(storedAvailableSheets, thumbnails, true);
        });
    };

    const handleTemplateLoading = (action, id, getTemplateFunction) => {
        getTemplateFunction(id)
            .then(async (response) => {
                let { FabricJs, MetaData } = response[0] || {};
                if(action === 'editProject'){
                    MetaData = response[0].metadata
                }
                let thumbnails = MetaData?.thumbnailInfo?.coverPic
                await loadTemplate(FabricJs?.sheets, thumbnails);
                dispatch(setLoading(false));
                dispatch(setIsEditing({ value: true, id: id, type: action }));
                dispatch(setShareImages(thumbnails));
                if(action === 'editProject'){
                    dispatch(setSharedId(response[0].StoryPostId));
                }
            })
            .catch((error) => {
                dispatch(setLoading(false));
                dispatch(showToast({ message: error.message, type: "error" }));
                setTimeout(()=>{
                    window.onbeforeunload = null;
                    window.location.href = '/';
                },5000)
            });
    };

    const jsonFetcher = () => {
        return fetch('https://fabricjsbucket.s3.amazonaws.com/file_820.json')
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok: ' + response.statusText);
                }
                return response.json();
            })
            .catch(error => {
                console.error('Fetch error:', error);
                throw error;
            });
    }

    const loadSheetJson = async (sheetJson, thumbnails, savedDesign, index) => {
        const newSheetX = new Sheet(sheetJson.size, {isStaringSheet: false}, 1.0, sheetJson.sheetTemplate, sheetJson.thumbnail, sheetJson.quantity);
        newSheetX.size = sheetJson.size;
            const objArr = [];
        sheetJson.objects.forEach((ex) => objArr.push(JSON.parse(ex)));
            const enlivenedList = await enlivenFabricObjectList(objArr);
        const enlivenedBg =  await enlivenFabricObjectList([sheetJson.backgroundImage]);
        newSheetX.id = sheetJson.id;
        const {fabricObjectList} = await getFabricInstances(enlivenedList, sheetJson);
            if(savedDesign){
                newSheetX.thumbnail = thumbnails && savedDesign ? thumbnails[index] : ''
            }else{
                newSheetX.thumbnail = thumbnails && thumbnails[`sheet_${index}`] ? URLMakerForThumbnails(thumbnails[`sheet_${index}`]) : ''
            }
            newSheetX.backgroundImage = enlivenedBg[0];
            newSheetX.objects = [...fabricObjectList];
            newSheetX.setSheetHistory(new History());
        return newSheetX
        }

    const loadTemplate = async (allSheets, thumbnails, savedDesign = false) => {
        await loadWebFonts();//loading fonts before everything else to resolve issue of getting wrong bounding boxes


        //loading sheets simultaneously to avoid to increase performance
        const sheetsPromises = allSheets.map((sheetJson, index) => loadSheetJson(sheetJson, thumbnails, savedDesign, index));

        const convertedSheets = await Promise.all(sheetsPromises);
        dispatch(setSheetList([...convertedSheets]));

        /* If bg issues come uncomment this code */

        // const {newSheet, sheetBg} = await initSheets([allSheets[0]], allSheets[0]);
        // dispatch(setActiveSheet(newSheet));
        // initCanvas(newSheet, sheetBg);

        /* And comment this one */
        const newSheet = convertedSheets[0];
        const sheetBg = newSheet.backgroundImage ?? false;
        dispatch(setActiveSheet(newSheet));
        initCanvas(newSheet, sheetBg);
    }

    const handleResize = () => {
        const canvasWrapper = canvasWrapperRef.current;
        resizeCanvas(canvasWrapper, canvas);
    };
    const resizeCanvas = (wrapper, canvas, pageToggle = false) => new Promise((resolve, reject) => {
        try {
            const wrapperHeight = wrapper.offsetHeight;
            const canvasRatio = ( window.activeSheet || activeSheet).size.width / (window.activeSheet || activeSheet).size.height;
            let canvasHeight = wrapperHeight - 50;
            let canvasWidth = canvasHeight * canvasRatio;

            canvas.setWidth(canvasWidth);
            canvas.setHeight(canvasHeight);

            const zoom = canvasWidth / ( window.activeSheet || activeSheet).size.width
            canvas.setZoom(zoom);
            canvas.renderAll();
        }catch (e) {
            console.log('resize is no done')
        }
    })
    const initCanvas = (initialSheet, sheetBg = false) => {
        getFabricCanvas(initialSheet).then((newCanvas) => {
            resizeCanvas(canvasWrapperRef.current, newCanvas);
                canvas = newCanvas;
                if (initialSheet.objects && !(initialSheet.objects[0] instanceof fabric.Object)) {
                    fabric.util.enlivenObjects(initialSheet.objects, (objects) => {
                        objects.forEach(obj => {
                            if(obj.type === 'image' && obj.feathering){
                                applyFeathering(obj, canvas)
                            }
                        });
                        canvas.add(...objects);
                        canvas.renderAll();
                    });
                }
                else{
                    canvas.add(...initialSheet.objects);
                    canvas.renderAll();
                }
                if(sheetBg)setCanvasBackground(canvas, sheetBg, dispatch, initialSheet)
                initEvents(canvas);
                handleKeyboardShortcuts(canvas, activeSheet, dispatch)
                dispatch(setFabricCanvasInstance(canvas));
                window.activeSheetId = initialSheet.id;
                window.activeSheet = initialSheet;
                window.canvas = canvas;
                updateUndoRedoState('init', 'init', canvas, window.activeSheet, dispatch);
                initAligningGuidelines(canvas)
                setTimeout(()=>{canvas.renderAll()},100)

        });
    };
    const initEvents = (canvas) => {
        canvas.on({
            'object:modified': modifiedObject,
            'object:added': addedObject,
            'object:removed': objectRemoved,
            'object:moving': objectMoved,
            'object:scaling': objectScaling,
            'selection:created': selectionCreated,
            'selection:updated': selectionUpdated,
            'text:changed': textChanged,
            'mouse:up': mouseUp,
            'mouse:over': mouseOver,
            'mouse:down': mouseDown,
            'mouse:out': mouseOut,
            'selection:cleared': selectionCleared,

        });
        initAligningGuidelines(canvas)
    };

    const mouseOver = (e) => {
        if (!e || !e.target) return
        e.target._renderControls(canvas.contextTop, {
            hasControls: false
        })
    }

    const mouseOut = () => {
        canvas.clearContext(canvas.contextTop);
    }

    const mouseDown = () => {
        canvas.clearContext(canvas.contextTop);
    }

    const stopEvents = () => {
        canvas.__eventListeners = {};
    };

    const textChanged = (event) => {
        dispatch(setTextValue(event.target.text))
    }

    const mouseUp = (event) => {
        // setTogglePage(false)
    }
    const objectScaling = () => {
    }

    const selectionCreated = (e) => {
        const canvasObject = e.selected[0];
        dispatch(setActiveObject(canvasObject));
        setActiveSettings(canvasObject);
        updateObjectsStates(canvasObject)
        if (canvasObject.type === 'textbox') {
            dispatch(setTextValue(canvasObject.text))
            setToggleSubMenu(true);
            dispatch(setPanelKey('1'))
        }
        else if (canvasObject.type === 'image') {
            setToggleSubMenu(true);
        }
    };
    const selectionCleared = () => {
        dispatch(setActiveObject(null));
        updateObjectsStates({name: "clear"})
        dispatch(setTextValue(''))
    };
    const selectionUpdated = (e) => {
        const canvasObject = e.selected[0];
        updateObjectsStates(canvasObject)
        dispatch(setActiveObject(canvasObject));
        setActiveSettings(canvasObject);
        if (canvasObject.type === 'textbox') {
            dispatch(setTextValue(canvasObject.text))
            dispatch(setPanelKey('1'))
            setToggleSubMenu(true);
        }
        else if (canvasObject.type === 'image') {
            setToggleSubMenu(true);
        }
    };
    const modifiedObject = (e) => {
        const canvasObject = e.target;
        setActiveSettings(canvasObject);
        createThumbnail(canvas).then((thumbnail) => dispatch(updateSheetThumbnail({
            sheetId: window.activeSheetId,
            thumbnail,
        })));
        updateUndoRedoState(e.target, 'modified', canvas, window.activeSheet, dispatch);
    };
    const objectMoved = (e) => {};
    const objectRemoved = (e) => {
        updateUndoRedoState(e.target, 'deleted', canvas, window.activeSheet, dispatch);
        createThumbnail(canvas).then((thumbnail) => dispatch(updateSheetThumbnail({
            sheetId: window.activeSheetId,
            thumbnail,
        })));
    };
    const addedObject = (e) => {
        const canvasObject = e.target;
        if(canvasObject.type === 'textbox'){
            canvasObject.set({objectCaching: false})
        }
        updateUndoRedoState(e.target, 'added', canvas, window.activeSheet, dispatch);
        if (!canvasObject.hasOwnProperty('generateThumbnail')) {
            createThumbnail(canvas).then((thumbnail) => dispatch(updateSheetThumbnail({
                sheetId: window.activeSheetId,
                thumbnail,
            })));
        }
    };

    const updateObjectsStates = (object) => {
        let obj;
        if (object.type === "textbox") {
            dispatch(setPanelKey('1'))
            obj = {
                image: false,
                objectActive: true,
                text: true,
                activeSelection: false
            }
        } else if (object.name === "clear") {
            obj = {
                image: false,
                objectActive: false,
                text: false,
                activeSelection: false
            }
        } else if (object.type === "image" || object?.type === 'group' || object?.type === 'path') {
            dispatch(setPanelKey('2'))
            obj = {
                image: true,
                objectActive: true,
                text: false,
                activeSelection: false
            }
        } else {
            obj = {
                image: false,
                objectActive: true,
                text: false,
                activeSelection: false
            }
        }
        dispatch(setObjectsState(obj))
    }

    const loadWebFonts = (canvas) => new Promise((resolve) => {
            WebFont.load({
                google: {
                    families: webFontList,
                },
                active() {
                    fabric.util.clearFabricFontCache();
                    canvas && canvas.renderAll();
                    resolve();
                },
            });
    });

    const TogglePage = () => {
        setTogglePage(!togglePage)
        setTimeout(() => {
            resizeCanvas(canvasWrapperRef.current, canvas, !togglePage)
        }, 100)
    }

    const setActiveSettings = (obj) => {
        if (obj) {
            let height = Math.floor(obj.getScaledHeight());
            let width = Math.floor(obj.getScaledWidth());
            let top = Math.floor(obj.top);
            let left = Math.floor(obj.left);
            let isLockMovement = obj.isLockMovement;
            let opacity = obj.opacity;

            if (obj.hasOwnProperty('group')) {
                height = Math.floor(obj.group.height);
                width = Math.floor(obj.group.width);
                top = Math.floor(obj.group.top);
                left = Math.floor(obj.group.left);
            }
            if (obj.type === 'i-text' || obj.type === 'textbox' || obj.type === 'text') {
                const {
                    fontFamily,
                    fontSize,
                    fontStyle,
                    fontWeight,
                    underline,
                    textCase,
                    shadow,
                    strokeWidth,
                    stroke,
                    isShadow,
                    isOutline,
                    textGradient,
                    lineHeight
                } = obj;
                const textAlignment = obj.textAlign;
                const textColor = obj.fill;
                const lineThrough = obj.linethrough;
                dispatch(setActiveSetting({
                    height,
                    width,
                    top,
                    left,
                    scaleX: obj.scaleX,
                    scaleY: obj.scaleY,
                    objectType: obj.type,
                    opacity,
                    fontFamily,
                    fontSize,
                    fontStyle,
                    textAlignment,
                    fontWeight,
                    underline,
                    textColor,
                    lineThrough,
                    textCase,
                    shadow,
                    strokeWidth,
                    stroke,
                    isShadow,
                    isOutline,
                    textGradient,
                    isLockMovement,
                    lineHeight
                }));
            } else {
                dispatch(setActiveSetting({
                    height,
                    width,
                    top,
                    left,
                    scaleX: obj.scaleX,
                    scaleY: obj.scaleY,
                    objectType: obj.type,
                    isLockMovement,
                    opacity
                }));
            }
        }
    };

    const undo = () => {
        canvas.discardActiveObject();
        const actSheet = availableSheets.find((f) => f.id === activeSheet.id);
        if (actSheet && actSheet.history.undoList.length > 0) {
            const initInd = actSheet.history.undoList[actSheet.history.undoList.length - 1];
            if (initInd.actionType !== 'init') {
                const lastAction = actSheet.history.undoList.pop();
                const newInd = actSheet.history.undoList[actSheet.history.undoList.length - 1];
                actSheet.history.redoList.push(lastAction);
                jsonLoader(newInd.json)
            }
        }
    };

    const redo = () => {
        canvas.discardActiveObject();
        const actSheet = availableSheets.find((f) => f.id === activeSheet.id);
        if (actSheet && actSheet.history.redoList.length > 0) {
            const lastAction = actSheet.history.redoList.pop();
            actSheet.history.undoList.push(lastAction);
            jsonLoader(lastAction.json)
        }
    };

    useEffect(() => {
        const handleKeyDown = (e) => {
            const isCtrlOrCmd = e.ctrlKey || e.metaKey;

            // Undo (Ctrl/Cmd + Z)
            if (isCtrlOrCmd && e.key === 'z' && !e.shiftKey) {
                e.preventDefault();
                undo();
            }

            if ((isCtrlOrCmd && e.key === 'y') || (isCtrlOrCmd && e.key === 'z' && e.shiftKey)) {
                e.preventDefault();
                redo();
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    const jsonLoader = (json) => {
        stopEvents();
        canvas.loadFromJSON(json, () => {
            canvas.renderAll();
            canvas._objects.forEach(obj=>{
                if (obj.type === 'image' && obj.feathering) {
                    applyFeathering(obj, canvas)
                }
            })
            initEvents(canvas);
            canvas.renderAll();
            createThumbnail(canvas).then((thumbnail) => dispatch(updateSheetThumbnail({
                sheetId: window.activeSheetId,
                thumbnail,
            })));
        });
    }

    return (
        <>
            <ToastContainer />
            <MainWrapper>
                {isLoading && <Loader/>}
                <Header/>
                <Box className='flebox'>
                    <Box className='left-side-col'>
                        <LeftSideBar canvasWrapperRef={canvasWrapperRef} resizeCanvas={handleResize} toggleSubMenu={toggleSubMenu} setToggleSubMenu={setToggleSubMenu} stopEvents={stopEvents} initEvents={initEvents}/>
                    </Box>
                    <Box className='main-content-center'>
                        <Toolbar  stopEvents={stopEvents} initEvents={initEvents} setToggleSubMenu={setToggleSubMenu} undo={undo} redo={redo} resizeCanvas={handleResize}/>
                        <ContentWrapper ref={canvasWrapperRef}>
                            <div className='CanvasWrapperDiv'>
                                <div className={`canvas-div myCanvasWrapper`}>
                                    <canvas id="after-life-canvas"/>
                                </div>
                            </div>
                        </ContentWrapper>
                        <div className='bottom-pages'>
                            <YourPage togglePage={togglePage} activeSheetIndex={activeSheetIndex} canvasWrapperRef={canvasWrapperRef} resizeCanvas={handleResize}/>
                            <div className={`toggle_menu_btn ${togglePage ? '' : 'toggle-btn'}`} onClick={TogglePage}>
                                {togglePage ? <TogglePageMenuOpen/> : <TogglePageMenuClose/>}
                            </div>
                        </div>
                    </Box>
                </Box>
            </MainWrapper>
        </>
    );
}

export default AfterLifeEditor;